interface BeckaAudience {
  flagsReady: boolean
  showChatWidget: boolean
}

export const shouldInitBecka = ({ flagsReady, showChatWidget }: BeckaAudience): boolean =>
  flagsReady && !showChatWidget
